import { formatWimName } from 'helpers/label.formatter';
import { NormalizedWimPlatform } from 'store/wim/normalization';
import { WimsListSort } from './types';

export const wimListSorters = {
  [WimsListSort.default]: (a: NormalizedWimPlatform, b: NormalizedWimPlatform) =>
    formatWimName(a.wim).localeCompare(formatWimName(b.wim), undefined, {
      numeric: true,
      sensitivity: 'base',
    }),
  [WimsListSort.last_updated]: (a: NormalizedWimPlatform, b: NormalizedWimPlatform) => {
    if (!a.lastTransitDatetime) {
      return -1;
    }
    if (!b.lastTransitDatetime) {
      return 1;
    }
    return a.lastTransitDatetime > b.lastTransitDatetime ? 1 : -1;
  },
};
